import { Switch as KSwitch, SwitchChangeEvent, SwitchProps } from '@progress/kendo-react-inputs';
import { FC, useId } from 'react';

interface KSwitchProps extends Omit<SwitchProps, 'checked'> {
  id?: string;
  value: boolean;
  onChange: (event: SwitchChangeEvent) => void;
  label?: string;
  onLabel?: string;
  offLabel?: string;
  disabled?: boolean;
  size?: null | 'small' | 'medium' | 'large';
  className?: string;
}

const Switch: FC<KSwitchProps> = ({
  id,
  value,
  onChange,
  label,
  onLabel,
  offLabel,
  disabled,
  ...props
}) => {
  let defaultId = useId();

  return (
    <span id={id}>
      <label htmlFor={defaultId}>
        <KSwitch
          {...props}
          onLabel={onLabel}
          offLabel={offLabel}
          checked={value}
          onChange={onChange}
          id={defaultId}
          disabled={disabled}
        />
        {label && <div>{label}</div>}
      </label>
    </span>
  );
};

export default Switch;
